import { useMemo } from 'react'

import type { Collection } from '@tribeplatform/gql-client/types'

import type { QueryClient } from '../../lib/react-query/QueryClient.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { getCollectionsKey } from '../../utils/keys/collection.key.js'

export const getCachedCollection = (
  id: string,
  queryClient: QueryClient,
): Collection => {
  const collectionsKey = getCollectionsKey()
  let cachedCollection: Collection

  const data = queryClient.getQueriesData<Collection[]>(collectionsKey)
  data?.forEach(([_, queryData]) => {
    queryData?.forEach(collection => {
      if (collection?.id === id) {
        cachedCollection = collection
      }
    })
  })
  return cachedCollection
}

export const useCachedCollection = (id: string): Collection => {
  const queryClient = useQueryClient()
  return useMemo(() => getCachedCollection(id, queryClient), [id, queryClient])
}
